<template>
  <v-container class="pa-0">
    <v-tabs v-model="tab" background-color="white" color="#d32f2f" dark>
      <v-tab>
        Veículos
      </v-tab>
      <v-tab>
        Produtos Força
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="mt-3">
      <v-tab-item>
        <v-row dense>
          <v-col cols="12">
            <Filtro />
          </v-col>
          <v-col cols="12">
            <Table />
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <v-row dense>
          <v-col cols="12">
            <FiltroProdutoForca />
          </v-col>
          <v-col cols="12">
            <TableProdutoForca />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
export default {
  name: "Financiamento",

  components: {
    Table: () => import("./components/Table"),
    Filtro: () => import("./components/Filtro"),
    TableProdutoForca: () => import("./produtoForca/components/Table"),
    FiltroProdutoForca: () => import("./produtoForca/components/Filtro")
  },

  data() {
    return {
      tab: null
    };
  }
};
</script>

<style scoped>
.v-tab:not(.v-tab--active) {
  color: #d32f2f !important;
}
</style>
